import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import moment from 'moment';
import * as _ from 'lodash';
import { LocationStrategy } from '@angular/common';
import { PreviousRouteService } from 'src/app/services/previousRouteService';
import BusinessEntity from 'src/app/services/businessEntity.model';
import FarmSiteModel from 'src/app/services/farmSite.model';
import CustomerDeviceModel from 'src/app/services/customerDevice.model';
import CustomerPondModel from 'src/app/services/customerPond.model';
import DeviceMovementModel from 'src/app/services/deviceMovement.model';
import { BusinessEntityService } from 'src/app/services/businessEntity.service';
import { FarmSiteService } from 'src/app/services/farmSite.service';
import { CustomerDeviceService } from 'src/app/services/customerDevice.service';
import { DeviceMovementService } from 'src/app/services/deviceMovement.service';
import { CustomerPondService } from 'src/app/services/customerPond.service';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-assign-device-to-farm',
  templateUrl: './assign-device-to-farm.component.html',
  styleUrls: ['./assign-device-to-farm.component.scss']
})
export class AssignDeviceToFarmComponent implements OnInit {
  public businessEntities: Array<BusinessEntity>;
  public businessEntitie: BusinessEntity;
  public farmsites: Array<FarmSiteModel>;
  public farmsite: FarmSiteModel;
  public customerDevices: Array<CustomerDeviceModel>;
  public customerDevice: CustomerDeviceModel | any;
  public customerPonds: Array<CustomerPondModel>;
  public customerPond: CustomerPondModel;
  public deviceMovement: DeviceMovementModel;
  public pgLoad = false;
  public personType: string;
  public config: any;
  public loginPersonType: string;
  public deviceId: any;
  public feedproviderId: string;
  public deviceNumber: string;
  public iscmorfp: any;
  public businessType: string;
  public business_id: string;
  public businessName: string;
  public allBusinesses: Array<BusinessEntity>;

  constructor(public route: ActivatedRoute, public businessEntityService: BusinessEntityService, public farmSiteService: FarmSiteService, public customerDeviceService: CustomerDeviceService, public deviceMovementService: DeviceMovementService, public customerPondService: CustomerPondService, public toastr: ToastrService, 
    private locationStrategy: LocationStrategy, private previousRouteService: PreviousRouteService
  ) {
    this.config = {
      itemsPerPage: 12,
      currentPage: 1,
    };
    this.businessEntitie = new BusinessEntity();
    this.farmsite = new FarmSiteModel();
    this.customerPond = new CustomerPondModel();
    this.customerDevice = new CustomerDeviceModel();
    this.deviceMovement = new DeviceMovementModel();
  }

  public async ngOnInit() {
    try {
      this.previousRouteService.setPreviousRoute(this.locationStrategy.path());
      this.loginPersonType = localStorage.getItem('loginPersonType');
      this.businessEntitie.id = '';
      this.allBusinesses = await this.businessEntityService.getAllBusinessEntity();
      this.route.params.subscribe(async params => {
        this.deviceId = params.deviceId;
        this.deviceNumber = params.deviceNumber;
        this.iscmorfp = params.isCM;
        this.businessType = params.type; // hardcoded -providerdevice
        if (this.businessType == 'Farm') {
          this.businessEntitie.id = params.providerid;
          await this.getAllstedetailsByBusinessId();
        } else if (params.providerid && params.deviceId) {
          this.feedproviderId = params.providerid;
          this.businessEntities = await this.businessEntityService.getFarmListByDevicewithProider(this.feedproviderId, this.deviceId);
        }
      });
      if (this.feedproviderId && this.deviceId) {
        this.businessEntities = await this.businessEntityService.getFarmListByDevicewithProider(this.feedproviderId, this.deviceId);
      }
      this.farmsite.id = '';
      this.customerPond.id = '';
    } catch (error: any) {
      this.toastr.error(error);
    }
  }

//To cancel ongoing requests and unsubscribe from subscriptions.
public ngOnDestroy(): void {
  this.businessEntityService.cancelOnGoingHttpRequests();
  this.farmSiteService.cancelOnGoingHttpRequests();
}

  // if select farm incms
  public async getAllstedetailsByBusinessId() {
    this.farmsite.id = '';
    try {
      this.farmsites = await this.farmSiteService.getFarmeSitesByFarmsId(this.businessEntitie.id);
      this.pgLoad = true;
    } catch (error: any) {
      this.toastr.error(error);
    }
  }

  // get pond details by farmsiteid
  public async getAllPondDetailsByFarmsiteId() {
    this.customerPond.id = '';
    try {
      this.customerPonds = await this.customerPondService.getAllPondDetailsByFarmsiteId(this.farmsite.id);
      this.pgLoad = true;
    } catch (error: any) {
      this.toastr.error(error);
    }
  }

  // assign device to farm if user comes to selected fp
  // assign device to pond if user comes selected cm
  public async assignDeviceToFarmId() {
    this.customerDevice.business_id = this.businessEntitie.id;
    this.customerDevice.device_id = this.deviceId;
    if (this.iscmorfp == 'true') {
      this.customerDevice.pond_id = this.customerPond.id;
      this.customerDevice.business_id = this.businessEntitie.id;
    }
    try {
      this.customerDevice = await this.customerDeviceService.assignDeviceToFarmId(this.customerDevice);
      if (this.customerPond.id) {
        this.toastr.success('Continuous monitoring device added to the Pond successfully');
      } else {
        this.toastr.success('Device added to farm successfully');
      }
      /*call add device moment service*/
      /*find business name by selected businessid*/
      if (!this.customerPond.id) {
        const selectedBusinessObj = _.filter(this.businessEntities, (o) => {
          return o.id == this.businessEntitie.id;
        });
        if (selectedBusinessObj.length > 0) {
          this.businessName = selectedBusinessObj[0].businessName;
        }
        /*find business name by selected businessid*/
        this.deviceMovement.from_loc = 2;
        this.deviceMovement.to_loc = 1;
        this.deviceMovement.business_id = this.businessEntitie.id;
        this.deviceMovement.to = this.businessName;
        this.deviceMovement.to_id = this.businessEntitie.id;
        this.deviceMovement.device_id = this.deviceId;
        this.deviceMovement.action_name = 'Map';
        this.deviceMovement.date = moment(new Date()).utc().format('YYYY-MM-DD');
        let dt = new Date();
        let dtime = dt.getHours() + ':' + dt.getMinutes() + ':' + dt.getSeconds();
        this.deviceMovement.time = dtime;
        this.deviceMovement.created_by = this.loginPersonType;
        this.deviceMovement.updated_by = this.loginPersonType;
        this.deviceMovement.provider_id = this.feedproviderId;
        this.deviceMovement = await this.deviceMovementService.deassignFun(this.deviceMovement);
      }
    } catch (error: any) {
      this.toastr.error(error);
    }
  }
  /*if click on cms to click assign device*/
}
